var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_857_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0027 0H13.44V1.43733H11.44V2.87467H13.44V4.312H10.0027V0ZM14.1267 0H17.5654V1.25067H15.5654V1.5H17.5654V4.37467H14.1267V3.06267H16.1267V2.812H14.1267V0ZM18.2534 0H21.6894V1.25067H19.6894V1.5H21.6894V4.37467H18.2534V3.06267H20.2534V2.812H18.2534V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.988 32L6.72933 29.4293L4 6.28933H28L25.272 29.4267L15.988 32ZM9.396 16.764L9.65067 19.6013H19.4867L19.1573 23.2813L15.992 24.1373H15.9893L12.8293 23.284L12.6267 21.0213H9.77733L10.1747 25.4773L15.988 27.0907L21.8107 25.4773L22.52 17.5253L22.5893 16.764L23.1013 11.0187H8.88533L9.144 13.8573H19.992L19.7333 16.764H9.396Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_857_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCss);
export default __webpack_public_path__ + "static/media/icon_css.f01c97f954d528c81eb11bf09468ebdc.svg";
export { ForwardRef as ReactComponent };